import {httpClient} from '@/main';
import PlanEditResultModel from '@/models/PlanEditResultModel';
import {WarehouseDescription} from '@/models/PlanEditModel';

export const fetchResult = (id: number) =>
    httpClient.get<PlanEditResultModel>('planRes/getExtendedView', {
        params: {
            id,
        },
    });

export const fetchResultConfig = (id: number) =>
    httpClient.get<string>('planRes/getCurrentConfig', {
        params: {
            id,
        },
    });

export const fetchSetResultConfig = (id: number, idResultConfig: number) =>
    httpClient.post('planRes/setCurrentConfig', null, {
        params: {
            id,
            idResultConfig,
        },
    });

export const fetchResultConfigsDescriptions = () => httpClient.get('resultConfig/getDescriptions');

export const fetchEquipmentTypesFormCatalogue = () =>
    httpClient.get<WarehouseDescription[]>('equipmentType/getDescriptions');
